
<template>
  <div class="home">
    <!-- 首页头部 -->
    <homeHeader :type="'home'"></homeHeader>
    <!-- 首页轮播图 -->
    <homeCarousel @sendActiveIndex="getActiveIndex"></homeCarousel>
    <!-- 首页底部-->
    <homeFooter></homeFooter>
    <!-- 联系我们二维码 -->
    <FollowPop :isShow="isShow"></FollowPop>
     <!-- 关注我们二维码 -->
    <linkUsPop :isShow="isShow1"></linkUsPop>
   
    <div class="scan-code-switch-container"  @mouseenter="handleIsFollow(true)" @mouseleave="handleIsFollow(false)">
      <div class="scan-code-switch d-flex flex-center">
        <img src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeet-official-website/08.png" alt="">
      </div>
      <div class="txt" :class="activeIndex ==1 ||  activeIndex ==7? 'cor-white' : 'cor-theme'">关注我们</div>
    </div>
    <!-- 联系我们 -->
    <div class="scan-code-switch-container1" @mouseenter="handleIsFollow1(true)" @mouseleave="handleIsFollow1(false)">
      <div class="scan-code-switch d-flex flex-center">
        <img src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeet-Static/WeMeet-mini/qiwei-logo.png" alt="" style="transform:scale(1.5) translateX(1.5px)">
      </div>
      <div class="txt" :class="activeIndex ==1 ||  activeIndex ==7? 'cor-white' : 'cor-theme'">联系我们</div>
    </div>
  </div>
</template>
<!-- 
  /* 适用于320px-480px范围内的屏幕 */
@media screen and (min-width: 320px) and (max-width: 480px) {
/* 这里是你的CSS样式 */
}

/* 适用于768px-1024px范围内的屏幕 */
@media screen and (min-width: 768px) and (max-width: 1024px) {
/* 这里是你的CSS样式 */
}

/* 适用于大于1024px的屏幕 */
@media screen and (min-width: 1024px) {
/* 这里是你的CSS样式 */
}
 -->
<script>
// import WmtHeader from '@/components/layout/wmtHeader.vue'
// import WmtFooter from '@/components/layout/wmtFooter.vue'
import homeHeader from '../../components/homeHeader.vue'
import FollowPop from '../../components/FollowPop.vue'
import linkUsPop from '../../components/linkUsPop.vue'
import homeCarousel from './components/homeCarousel.vue'
import homeFooter from '../../components/homeFooter.vue'
export default {
  name: 'Home',
  components: {
    homeHeader,
    homeCarousel,
    homeFooter,
    FollowPop,
    linkUsPop
  },
  data() {
    return {
      activeKey: 'home',
      isShow: false,
      isShow1: false,
      activeIndex: 1
    }
  },
  methods: {
    handleIsFollow(bool) {
      this.isShow1 = false
      this.isShow = bool
    },
    handleIsFollow1(bool) {
      this.isShow = false
      this.isShow1= bool
    },
    // handleIsFollow1(bool) {
    //   this.isShow1 = bool
    // },
    getActiveIndex(e) {
      // console.log("e",e)
      this.activeIndex = e
    },
   
  }
}
</script>

<style  scoped>
.home {
  min-width: 320px;
  margin: 0 auto;
}
.cor-theme {
  color: #00C4C9;
}
.cor-white {
  color: #fff;
}
.scan-code-switch-container1 {
  display: flex;
  flex-direction: column;
  position: fixed;
  z-index: 1300;
  bottom: 125px;
  right: 8px;
  cursor: pointer;
}
.scan-code-switch-container {
  display: flex;
  flex-direction: column;
  position: fixed;
  z-index: 1300;
  bottom: 185px;
  right: 8px;
  cursor: pointer;
}

@media screen and (max-width: 768px)  {
  .scan-code-switch-container1 {
    /* bottom: 9.5vh; */
    right: 8px;
  }
  .scan-code-switch-container {
    /* bottom: 18vh; */
    right: 8px;
  }
}
 .scan-code-switch {
  display: flex;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: #fff;
}
.scan-code-switch img {
  display: block;
  width: 17px;
  height: 17px;
}

 .txt {
  font-size: 8px;
  margin-top: 2px;
  cursor: pointer;
  text-wrap: nowrap;
}</style>